import { observable } from "mobx";
import FeeType from "./feeType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class CustomerRefundCandidateFeeResponse {
  @observable
  feeType!: FeeType;

  @observable
  amount!: number;
}
